const localizers = {
  'loading.msg': () => `Ladataan...`,
  'logon.message.msg': () => `Todennus vaaditaan. Anna kelvollinen käyttäjätunnus ja salasana.`,
  'logon.button.msg': () => `Kirjaudu sisään...`,
  'SASServer.logonError.msg': () => `Palvelimelle kirjautuminen ei onnistu.`,
  'SASServer.genericError.msg': () => `Palvelimeen ei saada yhteyttä.`,
}
export default localizers;
